import WebsiteModal from "modal/WebsiteModal";
import {handleHubspotForm} from "util/hubspot";

export default class HubspotFormModal extends WebsiteModal {

    constructor($elem) {
        super();
        this.$elem = $elem;
        this.formId = this.$elem.attr('data-form-id');
    }

    show() {
        super.show();
    }

    buildModal() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {type: "button", className: "modal__close-btn close-btn close-btn--small close-btn--dark js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__content"}, [
                        eotwJSXFactory('div', {className: "container container--960"}, [
                            eotwJSXFactory('div', {className: "modal__header"}, [
                                eotwJSXFactory('h2', {className: "heading heading--2"}, ["Contáctanos"]),
                                eotwJSXFactory('p', null, ["Completa el formulario siguiente y te pondremos en contacto con la persona indicada."])
                            ]),
                            eotwJSXFactory('form', {className: "modal__form form form--white"}, [
                                eotwJSXFactory('div', {className: "js-hubspot-container hubspot-container", 'data-hubspot-class': "contact-modal modal", 'data-portal-id': "2188024", 'data-form-id': this.formId})
                            ])
                        ])
                    ])
                ])
            ])
        );
    }

    buildElement() {
        this.buildModal();
        this.loadHubspotForm();
    }

    loadHubspotForm() {
        handleHubspotForm(this.$modal);
    }

    bindEvents() {
        //Noop
    }
}
